import React from 'react';
import { Spinner } from '@heroui/react';
import { useLanguage } from '../stores/language-store';

interface LoadingSpinnerProps {
  fullScreen?: boolean;
  size?: 'sm' | 'md' | 'lg';
  label?: string;
  variant?: 'inline' | 'page' | 'fullpage';
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  fullScreen = false, 
  size = 'lg',
  label,
  variant 
}) => {
  const { isRTL } = useLanguage();

  const getContainerClass = () => {
    if (variant) {
      const variantClasses = {
        inline: 'flex items-center justify-center min-h-[200px]',
        page: 'flex items-center justify-center min-h-[400px]',
        fullpage: 'flex items-center justify-center h-screen bg-gray-50 dark:bg-gray-900',
      };
      return variantClasses[variant];
    }
    
    return fullScreen 
      ? 'flex items-center justify-center h-screen bg-gray-50 dark:bg-gray-900'
      : 'flex items-center justify-center h-full min-h-[200px]';
  };

  return (
    <div className={`${getContainerClass()} ${isRTL ? 'rtl' : 'ltr'}`}>
      <div className="flex flex-col items-center gap-4">
        <Spinner 
          size={size} 
          color="primary"
          label={label}
          classNames={{
            circle1: 'border-b-primary',
            circle2: 'border-b-primary',
          }}
        />
      </div>
    </div>
  );
};

export default LoadingSpinner;